import moment from "moment"
import axios from "axios"
export default {
  namespaced: true,
  state: {
    loading: false,
    error: false,
    error_message: "",
    ip_address: localStorage.getItem("ip_address") || "",
    dialog: localStorage.getItem("ip_address") ? false : true,
  },
  mutations: {
    SET_LOADER(state, payload) {
      state.loading = payload
    },
    SET_DIALOG(state, payload) {
      state.dialog = payload
    },
    SET_IP(state, payload) {
      state.ip_address = payload
      localStorage.setItem("ip_address", payload)
    },
    SET_ERROR(state, payload) {
      state.error = payload.status
      state.error_message = payload.message
    },
  },
  actions: {
    sendRequest({ commit, dispatch }, payload) {
      commit("SET_LOADER", true)
      setTimeout(() => {
        if (payload == "http://localhost:8080/") {
          commit("SET_LOADER", false)
          commit("SET_ERROR", false)
          commit("SET_DIALOG", false)
          commit("SET_IP", payload)
          dispatch(
            "Global/alert",
            {
              value: true,
              text: "Welcome! Please login",
              type: "success",
            },
            { root: true }
          )
        } else {
          commit("SET_LOADER", false)
          commit("SET_DIALOG", true)
          commit("SET_ERROR", { status: true, message: "IP Tidak Cocok" })
          dispatch(
            "Global/alert",
            {
              value: true,
              text: "IP not Found",
              type: "error",
            },
            { root: true }
          )
        }
        commit("SET_LOADER", false)
      }, 1000)
    },
  },
  getters: {
    ip_address(state) {
      return state.ip_address
    },
    loading(state) {
      return state.loading
    },
    error(state) {
      return state.error
    },
    error_message(state) {
      return state.error_message
    },
    dialog(state) {
      return state.dialog
    },
  },
}
